import { render } from "./newCardComponent.vue?vue&type=template&id=27d7081a&scoped=true"
import script from "./newCardComponent.vue?vue&type=script&lang=js"
export * from "./newCardComponent.vue?vue&type=script&lang=js"

import "./newCardComponent.vue?vue&type=style&index=0&id=27d7081a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d7081a"]])

export default __exports__